import type { DiTypes } from "@iot-platform/core";

export const agentTypes = Object.seal({
    repositories: {
        AgentRepository: Symbol.for("AgentRepository"),
    },
} satisfies DiTypes);
